import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { CustomerProduct } from '../../types/CustomerProduct';
import { DataFetchError } from '../../utils/ErrorClass';

export const useCustomerProducts = () => {
  const [customerProducts, setCustomerProducts] = useState<CustomerProduct[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const itemsPerPage = 100;

  const fetchCustomerProducts = useCallback(async (page: number, query: string = '') => {
    try {
      const { data, error: dataError } = await supabase
      .rpc('get_customer_products', {
        search_query: query,
        page: page,
        items_per_page: itemsPerPage
      });

      if (dataError) {
        throw new DataFetchError("データの取得失敗: " + dataError.message);
      }

      setCustomerProducts(data as CustomerProduct[]);
      setTotalPages(Math.ceil((data[0]?.total_count || 0) / itemsPerPage));
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    fetchCustomerProducts(page, searchQuery);
  }, [page, searchQuery, fetchCustomerProducts]);

  return { customerProducts, page, totalPages, setPage, setSearchQuery, error };
};
